<script>
	import { onMount } from "svelte";
	import { scrollup } from "./resume.min.js";

	onMount(() => {
		scrollup();
	});

	export let data;
</script>

<nav
	class="navbar navbar-expand-lg navbar-dark bg-primary fixed-top"
	id="sideNav">
	<a class="navbar-brand js-scroll-trigger" href="#page-top">
		<span
			class="d-block d-lg-none">{data.nama_depan + ' ' + data.nama_belakang + ', ' + data.title}</span>
		<span class="d-none d-lg-block">
			<img
				class="img-fluid img-profile rounded-circle mx-auto mb-2"
				src="assets/img/profile.jpg"
				alt="" />
		</span>
	</a>
	<button
		class="navbar-toggler"
		type="button"
		data-toggle="collapse"
		data-target="#navbarSupportedContent"
		aria-controls="navbarSupportedContent"
		aria-expanded="false"
		aria-label="Toggle navigation">
		<span class="navbar-toggler-icon" />
	</button>
	<div class="collapse navbar-collapse" id="navbarSupportedContent">
		<ul class="navbar-nav">
			{#each data.menu as menu}
				<li class="nav-item">
					<a
						class="nav-link js-scroll-trigger"
						href="#{menu.toLowerCase()}">{menu}</a>
				</li>
			{/each}
		</ul>
	</div>
</nav>

<div class="container-fluid p-0">
	<section
		class="resume-section p-3 p-lg-5 d-flex align-items-center"
		id="about">
		<div class="w-100">
			<h2 class="mb-0">
				{data.nama_depan}
				<span class="text-primary">{data.nama_belakang}</span>
			</h2>
			<div class="subheading mb-5">
				{data.alamat}
				-
				{data.hp}
				-
				<a href="mailto:{data.email}">{data.email}</a>
			</div>
			<p class="lead mb-5">{data.experience}</p>
			<div class="social-icons">
				{#each data.medsos as d}
					<a href={d.link}> <i class={d.fa_icon} /> </a>
				{/each}
			</div>
		</div>
	</section>

	<hr class="m-0" />

	<section
		class="resume-section p-3 p-lg-5 d-flex justify-content-center"
		id="experience">
		<div class="w-100">
			<h2 class="mb-5">Experience</h2>

			{#each data.pengalaman as d}
				<div
					class="resume-item d-flex flex-column flex-md-row justify-content-between mb-5">
					<div class="resume-content">
						<h3 class="mb-0">{d.posisi}</h3>
						<div class="subheading mb-3">{d.perusahaan}</div>
						<p>{d.deskripsi}</p>
					</div>
					<div class="resume-date text-md-right">
						<span class="text-primary">{d.periode}</span>
					</div>
				</div>
			{/each}
		</div>
	</section>

	<hr class="m-0" />

	<section
		class="resume-section p-3 p-lg-5 d-flex align-items-center"
		id="education">
		<div class="w-100">
			<h2 class="mb-5">Education</h2>

			{#each data.pendidikan as d}
				<div
					class="resume-item d-flex flex-column flex-md-row justify-content-between mb-5">
					<div class="resume-content">
						<h3 class="mb-0">{d.institusi}</h3>
						<div class="subheading mb-3">{d.gelar}</div>
						<div>{d.prodi}</div>
						<p>GPA: {d.ipk}</p>
					</div>
					<div class="resume-date text-md-right">
						<span class="text-primary">{d.periode}</span>
					</div>
				</div>
			{/each}
		</div>
	</section>

	<hr class="m-0" />

	<section
		class="resume-section p-3 p-lg-5 d-flex align-items-center"
		id="skills">
		<div class="w-100">
			<h2 class="mb-5">Skills</h2>

			<div class="subheading mb-3">Programming Languages &amp; Tools</div>
			<ul class="list-inline dev-icons">
				{#each data.skills as skill}
					<li class="list-inline-item"><i class={skill} /></li>
				{/each}
			</ul>

			<div class="subheading mb-3">Workflow</div>
			<ul class="fa-ul mb-0">
				{#each data.workflow as workflow}
					<li><i class="fa-li fa fa-check" /> {workflow}</li>
				{/each}
			</ul>
		</div>
	</section>

	<hr class="m-0" />

	<section
		class="resume-section p-3 p-lg-5 d-flex align-items-center"
		id="interests">
		<div class="w-100">
			<h2 class="mb-5">Interests</h2>
			{#each data.interests as interest}
				<p>{interest}</p>
			{/each}
		</div>
	</section>

	<hr class="m-0" />

	<section
		class="resume-section p-3 p-lg-5 d-flex align-items-center"
		id="portfolio">
		<div class="w-100">
			<h2 class="mb-5">Portfolio</h2>
			<ul class="fa-ul mb-0">
				{#each data.portfolio as d}
					<li>
						<i class="fa-li fa fa-check text-warning" />
						<a href={d.link} alt="" target="blank">{d.nama}
							-
							{d.tahun}</a>
					</li>
				{/each}
			</ul>
		</div>
	</section>
</div>
